import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "14",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.344 6.35 1.578.965A.8.8 0 0 0 .781.947a.79.79 0 0 0-.404.692v10.717a.788.788 0 0 0 1.201.673l8.76-5.338a.79.79 0 0 0 .38-.673.8.8 0 0 0-.374-.668M15.119.613h-3.017a.504.504 0 0 0-.504.504V12.89c0 .275.222.504.504.504h3.017a.504.504 0 0 0 .504-.504V1.117a.5.5 0 0 0-.504-.504" }, null, -1)
  ])))
}
export default { render: render }